export const getUniqueId = () => {
  return Math.round(Math.random() * Math.pow(10, 20)).toString(36);
};
